
<template>
  <div class="select-room-box">
    <v-select box color="black" v-model="room" hide-details :suffix="modulePosition+1" :items="allowedRooms" item-text="classname" item-value="id" :disabled="disabledRoom" persistent-hint return-object single-line required></v-select>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['rooms', 'module-position', 'class-data', 'current-module'],
  data() {
    return {
      room: {},
      disabledRoom: true,
      allowedRooms: [ { classname: 'SEM SALA!', id: null } ],
      firstIterate: true
    }
  },
  methods: {
    setRoom() {
      if (this.classData.modules[this.modulePosition].days[0].room_id == null) {
        // this.room = { classname: 'SEM SALA!', id: null }
        this.room = { id: null }
      } else {
        this.room = { id: this.classData.modules[this.modulePosition].days[0].room_id }
      }
    },
    enableRoom() {
      if (this.classData.modules[this.modulePosition].days[0].day) {
        this.disabledRoom = false
        this.getDisps()
      }
    },
    getDisps() {
      this.$http.post(`classrooms/disponibility/unit/${this.classData.unit_id}`, {
        days: [
          moment(this.currentModule.days[0].day).format('YYYY-MM-DD'),
          moment(this.currentModule.days[0].day).add(1, 'days').format('YYYY-MM-DD'),
          moment(this.currentModule.days[0].day).add(2, 'days').format('YYYY-MM-DD'),
        ]
      }).then(data => {
        this.allowedRooms = []
        this.rooms.forEach((item, ind) => {
          if (!data.data.includes(item.id)) {
            this.allowedRooms.push(item)
          }
        })
        this.allowedRooms.push({ classname: 'SEM SALA!', id: null })
        if (this.classData.modules[this.modulePosition].days[0].room_id != null) {
          this.allowedRooms.push({ id: this.classData.modules[this.modulePosition].days[0].room_id, classname: this.classData.modules[this.modulePosition].days[0].room_name })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created() {
    this.setRoom()
    this.enableRoom()
  },
  watch: {
    room(currentRoom, oldRoom) {
      if (this.firstIterate) {}
      else if (currentRoom.id != null) {
        this.$emit('roomChanged', {currentRoom, currentModule: this.currentModule, modulePosition: this.modulePosition })
      }
      this.firstIterate = false
    },
    rooms(newRooms, oldRooms) {
      this.allowedRooms = [{ classname: 'SEM SALA!', id: null }].concat(newRooms)
    },
    currentModule: {
      immediate: true,
      deep: true,
      handler(newModule, oldModule) {
        if (newModule.days[0].day != null) {
          this.enableRoom()
        }
        if (!this.firstIterate) {
          console.log('OLHEI!')
          if (this.currentModule.days[0].room_id == null) {
            this.room = { id: null }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  .select-room-box {
    
  }
</style>
